import { render, staticRenderFns } from "./NavBarFooter.vue?vue&type=template&id=49bcab8d"
import script from "./NavBarFooter.vue?vue&type=script&lang=js"
export * from "./NavBarFooter.vue?vue&type=script&lang=js"
import style0 from "./NavBarFooter.vue?vue&type=style&index=0&id=49bcab8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports